
import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import hisService from "services/admin/masters/hisService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import { MAPPING_SELECT_ERROR_TEMPLATE } from "constants/admin/masters/his";
import { ERROR_MESSAGE_UNKNOWN, MSG_RECORD_CREATE, MSG_RECORD_DELETE, MSG_RECORD_UNDO_DELETE, MSG_RECORD_UPDATE } from "constants/common";
import {getMatrixId} from "utils/matriceHelpers";
function ManageHisBiosBmc() {

  const [breamcrumbs, setBreamcrumbs] = useState([
    { title: "HIS Masters Mapping", url: "/admin/master/his/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new hisService();
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [mappingList, setMappingList] = useState([{}]);
  const [biosBmcList, setBiosBmcList] = useState([]);
  const [servicePackList, setServicePackList] = useState([]);
  const [selectedCombineKeys, setSelectedCombineKeys] = useState(null);
  const [selectedBiosBmc, setSelectedBiosBmc] = useState(null);
  const [selectedServicePack, setSelectedServicePack] = useState(null);
  const [combineKeyError, setCombineKeyError] = useState("");
  const [biosBmcError, setBiosBmcError] = useState("");
  const [servicePackError, setServicePackError] = useState("");
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [itemToBeEdited, setItemToBeEdited] = useState(null);
  const [isDeleteConfirmationShown, setIsDeleteConfirmationShown] = useState(false);
  const [isRestoreConfirmationShown, setIsRestoreConfirmationShown] = useState(false);
  const [deleteConfirmationMessage, setDeleteConfirmationMessage] = useState("");
  const [restoreConfirmationMessage, setRestoreConfirmationMessage] = useState("");
  const [itemToBeDeletedOrRestored, setItemToBeDeletedOrRestored] = useState(null);

  const Id = getMatrixId(window.location.pathname);

  useEffect(() => getMappingData(), []);

  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateMappingForm();
    }
  }, [selectedCombineKeys, selectedBiosBmc, selectedBiosBmc]);

  useEffect(() => {
    // populate details of item to be edited
    if (isEditMode) {
      populateItemDetailsToEdit();
    }
  }, [itemToBeEdited?.record_details?.id]);

  const getMappingData = () => {
    serviceObj.getAllInitialData(Id)
      .then((response) => {
        setMappingList(response?.his_bios_bmc_mapping_list);
        extractAndSetCombineKeys(response?.his_combine_keys);
        extractAndSetBiosBmc(response?.bios_bmc_master_drop_list);
        extractAndSetServicePack(response?.server_service_pack_master_drop_list);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
      });
  };

  // setting Combine keys
  const extractAndSetCombineKeys = (dataList) => {
    const combineKeyList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    setCombineKeyList(combineKeyList);
  };

  // setting biosBmc list
  const extractAndSetBiosBmc = (dataList) => {
    console.log({dataList})
    const biosBmcList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setBiosBmcList(biosBmcList);
  };

  // setting service pack
  const extractAndSetServicePack = (dataList) => {
    const servicePackList = dataList?.map((item) => ({
      id: item?.id,
      value: item?.name,
      label: item?.name,
      disabled: item?.disabled
    }));
    setServicePackList(servicePackList);
  };

  // reset form values, error messages, form state, edit mode, target edit item
  const resetForm = () => {
    resetFormValues();
    resetErrorMessages();
    setIsFormTouched(false);
    setIsEditMode(false);
    setItemToBeEdited(null);
  };

  // append offending field name in error message
  const getSelectErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };

  // validate fields and set or reset error message
  const validateMappingForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getSelectErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }

    if (!selectedBiosBmc) {
      setBiosBmcError(getSelectErrorMessageFor("BIOS/BMC"));
      isFormValid = false;
    } else {
      setBiosBmcError("");
    }

    return isFormValid;
  };

  // reset field values
  const resetFormValues = () => {
    setSelectedCombineKeys(null);
    setSelectedBiosBmc(null);
    setSelectedServicePack(null);
  };

  // reset error messages
  const resetErrorMessages = () => {
    setCombineKeyError("");
    setBiosBmcError("");
    setServicePackError("");
  };

  // api call for adding new mapping
  const addMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();

    // call POST api if form is valid
    if (isFormValid) {
      let payload = {
        bios_bmc_id: selectedBiosBmc?.id,
        server_service_pack_id: selectedServicePack?.id,
        his_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      serviceObj.createBiosBmcMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getMappingData();
        resetForm();
      });
    }
  };

  // process target item for editing
  const populateItemDetailsToEdit = () => {
    const combineKeysToEdit = itemToBeEdited?.his_combine_keys?.map((item) => ({
      id: item?.id,
      value: item?.combine_key,
      label: item?.combine_key,
      disabled: item?.disabled
    }));
    const biosBmcToEdit = {
      id: itemToBeEdited?.record_details?.bios_bmc_id,
      value: itemToBeEdited?.record_details?.bios_bmc,
      label: itemToBeEdited?.record_details?.bios_bmc
    };
    const servicePackToEdit = {
      id: itemToBeEdited?.record_details?.server_service_pack_id,
      value: itemToBeEdited?.record_details?.server_service_pack,
      label: itemToBeEdited?.record_details?.server_service_pack
    };
    setSelectedCombineKeys(combineKeysToEdit);
    setSelectedBiosBmc(biosBmcToEdit);
    setSelectedServicePack(servicePackToEdit);
  };

  // fetch details of item to be edited
  const editMapping = (data) => {
    setIsEditMode(true);
    // fetch details of item to edit
    serviceObj.getBiosMappingDetails(data?.id).then((response) => {
      setItemToBeEdited(response);
    })
      .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN));
  };

  // update 
  const updateMappingById = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    const isFormValid = validateMappingForm();
    if (isFormValid) {
      const payload = {
        bios_bmc_id: selectedBiosBmc?.id,
        server_service_pack_id: selectedServicePack?.id,
        his_combine_keys: selectedCombineKeys?.map(key => key?.id)
      };
      const targetItemId = itemToBeEdited?.record_details?.id;
      serviceObj.updateBiosMappingById(targetItemId, payload).then((response) => {
        toast.success(MSG_RECORD_UPDATE);
        getMappingData();
        resetForm();
      })
        .catch(error => toast.error(ERROR_MESSAGE_UNKNOWN)
        );
    }
  };

  // delete or restore mapping
  const deleteOrRestoreMappingById = () => {
    const { id, is_deleted } = itemToBeDeletedOrRestored;
    serviceObj.deleteBiosMappingById(id)
      .then((response) => {
        // show deleted or restored message based on is_deleted property
        if (is_deleted) {
          toast.success(MSG_RECORD_UNDO_DELETE);
          setIsRestoreConfirmationShown(false);
          setRestoreConfirmationMessage("");
        } else {
          toast.success(MSG_RECORD_DELETE);
          setIsDeleteConfirmationShown(false)
          setDeleteConfirmationMessage("");
        }
        resetForm();
        setItemToBeDeletedOrRestored(null);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setIsDeleteConfirmationShown(false)
        setDeleteConfirmationMessage("");
        setItemToBeDeletedOrRestored(null);
      })
      .finally(() => getMappingData());
  };

  // show delete warning confirmation popup
  const deleteMappingHandler = (rowData) => {
    setIsDeleteConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setDeleteConfirmationMessage(`Are you sure you want to remove ${rowData?.bios_bmc} with Combine Key ${rowData?.his_combine_key}?`)
  };

  // show restore warning confirmation popup
  const restoreMappingHandler = (rowData) => {
    setIsRestoreConfirmationShown(true);
    setItemToBeDeletedOrRestored(rowData);
    setRestoreConfirmationMessage(`Are you sure you want to restore ${rowData?.bios_bmc} with Combine Key ${rowData?.his_combine_key}?`);
  };

  // hide confirmation message and reset target item
  const cancelDeleteItem = () => {
    setIsDeleteConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
  };

  // hide confirmation message and reset target item
  const cancelRestoreItem = () => {
    setIsRestoreConfirmationShown(false);
    setItemToBeDeletedOrRestored(null);
    setRestoreConfirmationMessage("")
  };

  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breamcrumbs} disableEditTitle={true} />
      {isDeleteConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelDeleteItem}
        >
          {deleteConfirmationMessage}
        </ConfirmBox>
      }
      {isRestoreConfirmationShown &&
        <ConfirmBox
          actionHandler={deleteOrRestoreMappingById}
          handleSubmit={deleteOrRestoreMappingById}
          cancelDeleteItem={cancelRestoreItem}
        >
          {restoreConfirmationMessage}
        </ConfirmBox>
      }
      <div className="form-group d-flex">
        <div className="col-sm-6">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                {/* Combine key */}
                <div className="form-group">
                  <label htmlFor={"combineKey"} className="mr-sm-2 mt-2"><b>HIS Combine Key</b></label>
                  {/* add multi select dropdown */}
                  <Select
                    isMulti
                    id="combineKey"
                    name="Combine Key"
                    options={combineKeyList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedCombineKeys(selectedKeys)}
                    value={selectedCombineKeys}
                    isOptionDisabled={option => option.disabled}
                  />
                  {
                    combineKeyError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{combineKeyError}</div>
                  }
                </div>
                {/* bios bmc */}
                <div className="form-group">
                  <label htmlFor={"biosBmc"} className="mr-sm-2"><b>BIOS/BMC</b></label>
                  <Select
                    name="biosBmc"
                    id="biosBmc"
                    options={biosBmcList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedBiosBmc(selectedKeys)}
                    value={selectedBiosBmc}
                    isOptionDisabled={option => option.disabled}
                    isDisabled={isEditMode}
                  />
                  {biosBmcError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{biosBmcError}</div>
                  }
                </div>
                {/* service pack */}
                <div className="form-group">
                  <label htmlFor={"servicePack"} className="mr-sm-2"><b>Server Service Pack</b></label>
                  <Select
                    name="servicePack"
                    id="servicePack"
                    options={servicePackList}
                    classNamePrefix="select"
                    onChange={selectedKeys => setSelectedServicePack(selectedKeys)}
                    value={selectedServicePack}
                    isOptionDisabled={option => option.disabled}
                    disabled={false}
                  />
                  {servicePackError
                    &&
                    <div className="col-sm-10 mb-2 text-danger">{servicePackError}</div>
                  }
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <button type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2">
                <i className="fa fa-refresh"></i> Reset</button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                onClick={isEditMode ? updateMappingById : addMapping}
              >
                {isEditMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-6">
          <MaterialTable
            title="BIOS/BMC Mappings"
            columns={[
              { title: "Combine Key", field: "his_combine_key" },
              { title: "BIOS/BMC", field: "bios_bmc" },
              { title: "Server Service Pack", field: "server_service_pack" },
            ]}
            data={mappingList}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400
            }}

            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={
              [
                (rowData) => ({
                  icon: "edit",
                  tooltip: !rowData.is_deleted && "Edit Record",
                  onClick: (e, data) => editMapping(data),
                  hidden: !rowData?.id || rowData.is_deleted // display action only if any valid item is present
                }),
                (rowData) => ({
                  icon: rowData.is_deleted ? "undo" : "delete",
                  tooltip: rowData.is_deleted ? "Undo Deleted Record" : "Delete Record",
                  onClick: (e, data) => rowData.is_deleted ? restoreMappingHandler(data) : deleteMappingHandler(data),
                  hidden: !rowData?.id // display action only if any valid item is present
                })
              ]}
          />
        </div>
      </div>
    </div>
  )
}

export default ManageHisBiosBmc;